<template>
  <el-form-item :label="title">
    <el-date-picker
      v-model="value"
      type="daterange"
      range-separator="-"
      start-placeholder="From"
      end-placeholder="To"
      format="dd MMM yyyy"
      value-format="yyyy-MM-dd"
      size="mini"
    ></el-date-picker>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'

export default {
  name: 'InputDateRangePicker',
  props: {
    title: {
      type: String,
      required: false
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    isRequire: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter)
      },
      set (val) {
        save(this.setter, val)
      }
    }
  }
}
</script>
